window.updatePrices = function (currency) {
  const rates = { AED: 1, SAR: 1.02 };
  document.querySelectorAll(".currency-price").forEach((el) => {
    const aedPrice = parseFloat(el.dataset.aedPrice);
    if (!isNaN(aedPrice)) {
      const converted = (aedPrice * rates[currency]).toFixed(2);
      el.textContent = `${converted} ${currency}`;
    }
  });
};

//Swiper Slider Home page
try {
  let swiperContainer = document.querySelector(
      ".custom-collection-swiper-container"
    );
    if(swiperContainer){
  document.addEventListener("DOMContentLoaded", () => {
    const containers = document.querySelectorAll(
      ".custom-collection-swiper-container"
    );
    function updateSlidesPerView() {
      containers.forEach((container) => {
        if (window.innerWidth > 1920) {
          container.setAttribute("slides-per-view", "4");
        } else if (window.innerWidth > 1024) {
          container.setAttribute("slides-per-view", "4");
        } else if (window.innerWidth > 768) {
          container.setAttribute("slides-per-view", "3");
        } else if (window.innerWidth > 525) {
          container.setAttribute("slides-per-view", "2");
        } else {
          container.setAttribute("slides-per-view", "1.4");
        }
      });
    }
    updateSlidesPerView();
    window.addEventListener("resize", updateSlidesPerView);
  });
  }
} catch (error) {}

//Footer
try {
  let containers = document.querySelectorAll(".footer-main");
  containers.forEach((con) => {
    con.addEventListener("click", () => {
      let dropdown = con.parentElement.querySelector(".footer-dropdown");
      if (dropdown.style.opacity === "1") {
        dropdown.style.display = "none";
        dropdown.style.opacity = "0";
        dropdown.style.height = "0";
        dropdown.previousElementSibling.querySelector(".plus-faq").innerHTML =
          "+";
      } else {
        dropdown.style.display = "flex";
        dropdown.style.opacity = "1";
        dropdown.style.height = "auto";
        dropdown.previousElementSibling.querySelector(".plus-faq").innerHTML =
          "-";
      }
    });
  });
  let footerMainMenu = document.querySelectorAll(".footer-menu-main");
  footerMainMenu.forEach((menu) => {
    menu.addEventListener("click", () => {
      let dropdownMenu = menu.nextElementSibling;
      if (dropdownMenu.style.display === "flex") {
        dropdownMenu.style.display = "none";
        dropdownMenu.style.opacity = "0";
        dropdownMenu.style.height = "0";
        dropdownMenu.previousElementSibling.querySelector(
          ".plus-faq-menu"
        ).innerHTML = "+";
      } else {
        dropdownMenu.style.display = "flex";
        dropdownMenu.style.opacity = "1";
        dropdownMenu.style.height = "auto";
        dropdownMenu.previousElementSibling.querySelector(
          ".plus-faq-menu"
        ).innerHTML = "-";
      }
    });
  });
} catch (error) {}

//Main Menu
try {
  let mainMenu = document.querySelector(".navbar-mobile-menu");
  let menuOpenBtn = document.querySelector(".navbar-mobile-menu-icon");
  if(mainMenu){
  let menuCloseBtn = document.querySelector(
    ".navbar-menu-mobile-wrapper-close-btn"
  );
  mainMenu.style.left = "-350px";
  menuOpenBtn.addEventListener("click", () => {
    if (mainMenu.style.left == "-350px") {
      mainMenu.style.left = "0px";
      menuCloseBtn.style.left = "350px";
      menuCloseBtn.style.opacity = "100";
    }
  });
  menuCloseBtn.addEventListener("click", () => {
    if (mainMenu.style.left == "0px") {
      mainMenu.style.left = "-350px";
      menuCloseBtn.style.left = "0";
      menuCloseBtn.style.opacity = "0";
    }
  });
  }
} catch (error) {}

//Search Bar
// try {
//   let serachBar = document.querySelector(".navbar-search-bar");
//   let searchIcon = document.querySelector(
//     ".custom-navbar-right-search-bar img"
//   );
//   if(serachBar){
//   let redirectToSearch = () => {
//     let query = serachBar.value.trim();
//     if (query) {
//       window.location.href = `/search?q=${encodeURIComponent(query)}`;
//     }
//   };
//   serachBar.addEventListener("keypress", (event) => {
//     if (event.key === "Enter") {
//       redirectToSearch();
//     }
//   });
//   searchIcon.addEventListener("click", () => {
//     if (window.innerWidth > 1301) {
//       redirectToSearch();
//     }
//   });
//   }
// } catch (error) {}

// Cart Drawer

let cartDrawer = document.querySelector(".cart-drawer");
let cartOpenBtn = document.querySelector(".custom-navbar-right-cart");
let cartCloseBtn = document.querySelector(".cart-close-btn");
let cartCon = document.querySelector(".cart-drawer-container");
if (!window.location.href.includes("/cart")) {
  cartOpenBtn.addEventListener("click", () => {
    cartDrawer.classList.add("cart-toggle");
    cartCon.classList.add("cart-container-toggle");
  });
  cartCloseBtn.addEventListener("click", () => {
    cartDrawer.classList.remove("cart-toggle");
    cartCon.classList.remove("cart-container-toggle");
  });
  cartCon.addEventListener("click", (e) => {
    e.stopPropagation();
    if (e.target.closest(".cart-drawer")) {
      return;
    } else {
      cartDrawer.classList.remove("cart-toggle");
      cartCon.classList.remove("cart-container-toggle");
    }
  });
}

//Search Drawer
try {
  let searchDrawerCon = document.querySelector(".custom-search-drawer-container");
  let searchDrawer = document.querySelector(".custom-search-drawer");
  let searchDrawerOpenBtn = document.querySelectorAll(".search-bar-open");
  let searchDrawerCloseBtn = document.querySelector(".search-drawer-close-btn");
  let serachBarDrawer = document.querySelector(".searchBar-Input");
  let searchResultContainer = document.querySelector(
    ".search-result-container"
  );

  // Drawer open
  searchDrawerOpenBtn.forEach((openBtn) => {
    openBtn.addEventListener("click", () => {
       searchDrawer.classList.add("search-drawer-class");
       searchDrawerCon.classList.add("search-con-class");
    });
  });

  // Drawer close
  searchDrawerCloseBtn.addEventListener("click", () => {
   searchDrawer.classList.remove("search-drawer-class");
       searchDrawerCon.classList.remove("search-con-class");
  });

  searchDrawerCon.addEventListener("click", (e) => {
    e.stopPropagation();
    if(e.target.closest(".custom-search-drawer")) return;
    searchDrawer.classList.remove("search-drawer-class");
    searchDrawerCon.classList.remove("search-con-class");
  });

  // Fetch search suggestions
  async function searchDrawerQuery() {
    let query = serachBarDrawer.value.trim();

    if (query !== "") {
      const locale = window.location.pathname.includes("/ar") ? "ar" : "en";

      let fetched = await fetch(
        `/search/suggest.json?q=${encodeURIComponent(
          query
        )}&resources[type]=product&locale=${locale}`
      );
      let data = await fetched.json();
      let productData = data.resources.results.products;

      updateSearchResult(productData);
    } else {
      searchResultContainer.innerHTML = `
        <svg fill="#000000" version="1.1" xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 295.996 295.996">
          <g>
            <path d="M147.998,0C66.392,0,0,66.392,0,147.998c0,81.606,66.392,147.998,147.998,147.998
            c81.606,0,147.998-66.392,147.998-147.998C295.996,66.392,229.605,0,147.998,0z"/>
          </g>
        </svg>
        <p>No Search Result Found!</p>
      `;
    }
  }

  // Update search result
  function updateSearchResult(productData) {
    if (productData.length !== 0) {
      let resultProduct = ``;
      
      const countryCode = document.querySelector(".custom-search-drawer-container").getAttribute("countryCode");
      console.log(countryCode);

      // console.log(productData);
      productData.forEach((product) => {
        let showProduct = true;

        // For AE: hide KSA products
        if (countryCode === 'AE' && product.handle.includes('ksa')) {
          showProduct = false;
        }

        // For SA: only show KSA products
        if (countryCode === 'SA' && !product.handle.includes('ksa')) {
          showProduct = false;
        }

        if (!showProduct) return; // skip product

        resultProduct += `
            <a href="${product.url}">
              <div class="searched-product">
                <div class="searched-product-img">
                  <img src="${
                    product.featured_image.url
                  }" alt="product_img" loading="lazy">
                </div>
                <div class="searched-product-text-content">
                  <p class="searched-product-title">${product.title}</p>
                  <div class="searched-product-price">
                    <p class="currency-price" data-aed-price="${
                      product.price_max
                    }">
                      ${product.price_max} AED
                    </p>
                    ${
                      product.compare_at_price_max > product.price_max
                        ? `<span class="currency-price" data-aed-price="${product.compare_at_price_max}" style="text-decoration: line-through; text-decoration-color: red;">
                            ${product.compare_at_price_max} AED
                          </span>`
                        : ""
                    }
                  </div>
                </div>
              </div>
            </a>
          `;
      });

      searchResultContainer.innerHTML =
        resultProduct ||
        `
        <svg width="200px" height="200px" viewBox="0 0 128 128" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <defs> <style>.cls-1{fill:#000000;}</style> </defs> <title></title> <g data-name="Layer 2" id="Layer_2"> <g id="Export"> <path class="cls-1" d="M64,3A61,61,0,1,1,3,64,61.06,61.06,0,0,1,64,3m0-3a64,64,0,1,0,64,64A64,64,0,0,0,64,0Z"></path> <path class="cls-1" d="M86.26,94.81a1.47,1.47,0,0,1-.85-.26,38,38,0,0,0-24.09-6.7A37.48,37.48,0,0,0,42.6,94.54a1.5,1.5,0,1,1-1.72-2.46,40.5,40.5,0,0,1,20.23-7.22,41,41,0,0,1,26,7.22,1.5,1.5,0,0,1-.85,2.73Z"></path> <path class="cls-1" d="M43.83,60.63a9.34,9.34,0,0,1-8.28-5,1.5,1.5,0,1,1,2.64-1.41,6.39,6.39,0,0,0,11.27,0,1.5,1.5,0,1,1,2.65,1.41A9.37,9.37,0,0,1,43.83,60.63Z"></path> <path class="cls-1" d="M85.57,60.63a9.34,9.34,0,0,1-8.28-5,1.5,1.5,0,1,1,2.64-1.41,6.39,6.39,0,0,0,11.27,0,1.5,1.5,0,1,1,2.64,1.41A9.34,9.34,0,0,1,85.57,60.63Z"></path> </g> </g> </g></svg>
        <p>No Search Result Found!</p>
      `;
    } else {
      searchResultContainer.innerHTML = `
       <svg width="200px" height="200px" viewBox="0 0 128 128" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <defs> <style>.cls-1{fill:#000000;}</style> </defs> <title></title> <g data-name="Layer 2" id="Layer_2"> <g id="Export"> <path class="cls-1" d="M64,3A61,61,0,1,1,3,64,61.06,61.06,0,0,1,64,3m0-3a64,64,0,1,0,64,64A64,64,0,0,0,64,0Z"></path> <path class="cls-1" d="M86.26,94.81a1.47,1.47,0,0,1-.85-.26,38,38,0,0,0-24.09-6.7A37.48,37.48,0,0,0,42.6,94.54a1.5,1.5,0,1,1-1.72-2.46,40.5,40.5,0,0,1,20.23-7.22,41,41,0,0,1,26,7.22,1.5,1.5,0,0,1-.85,2.73Z"></path> <path class="cls-1" d="M43.83,60.63a9.34,9.34,0,0,1-8.28-5,1.5,1.5,0,1,1,2.64-1.41,6.39,6.39,0,0,0,11.27,0,1.5,1.5,0,1,1,2.65,1.41A9.37,9.37,0,0,1,43.83,60.63Z"></path> <path class="cls-1" d="M85.57,60.63a9.34,9.34,0,0,1-8.28-5,1.5,1.5,0,1,1,2.64-1.41,6.39,6.39,0,0,0,11.27,0,1.5,1.5,0,1,1,2.64,1.41A9.34,9.34,0,0,1,85.57,60.63Z"></path> </g> </g> </g></svg>
        <p>No Search Result Found!</p>
      `;
    }
  }

  // Trigger search
  let searchIcon = document.querySelector(".search-drawer-search-bar img");
  searchIcon.addEventListener("click", async () => {
    searchResultContainer.style.opacity = ".2";
    await searchDrawerQuery();
    const savedCurrency = localStorage.getItem("selectedCurrency") || "AED";
    updatePrices(savedCurrency);
    searchResultContainer.style.opacity = "1";
  });

  serachBarDrawer.addEventListener("keypress", async (e) => {
    if (e.key === "Enter") {
      searchResultContainer.style.opacity = ".2";
      await searchDrawerQuery();
      const savedCurrency = localStorage.getItem("selectedCurrency") || "AED";
      updatePrices(savedCurrency);
      searchResultContainer.style.opacity = "1";
    }
  });
} catch (error) {
  console.error(error);
}

//Review App Heading
try {
   let reviewAppH2Container = document.querySelector(
      ".jdgm-carousel-title-and-link"
    );
  if (reviewAppH2Container) {
    let reviewAppH2ContainerNew = `
    <div class="review-app-h2">
        <h2><span>1500+ glowing reviews</span> – Silky comfort,
    loved by many!</h2>
    </div>
    `;
    let reviewAppH2ContainerNewArabic = `
   <div class="review-app-h2">
    <h2><span>أكثر من ١٥٠٠ تقييم إيجابي</span> - راحة حريرية، محبوبة من الكثيرين!</h2>
    </div>
  `;
    if (window.location.href.includes("/ar")) {
      reviewAppH2Container.innerHTML = reviewAppH2ContainerNewArabic;
    } else {
      reviewAppH2Container.innerHTML = reviewAppH2ContainerNew;
    }
  }
} catch (error) {}

//Product Page ADD TO CART FUNCTIONS
// try {
//   const variantRadios = document.querySelectorAll(".variant-radio");
//   const addToCartBtn = document.querySelector(".a-t-c-btn");
//   const buyNowBtn = document.querySelector(".buy-product-btn");
//   const quantityInput = document.querySelector(".product-quantity-input");
//   const productEl = document.querySelector(".custom-product");
//   const notificationBar = document.querySelector(".notification-bar-bottom");

//   // 🔹 Parse variant JSON from product element
//   const variants = JSON.parse(productEl.getAttribute("product-variant-json") || "[]");

//   // --- Find selected variant ID ---
//   function getSelectedVariantId() {
//     const selectedValues = [];
//     const groups = ["productSizes", "productColor"]; // match your input name attributes

//     groups.forEach((group) => {
//       const checked = document.querySelector(`input[name="${group}"]:checked`);
//       if (checked) selectedValues.push(checked.value);
//     });

//     if (!selectedValues.length) return null;

//     const match = variants.find((v) =>
//       v.options.every((opt, i) => opt === selectedValues[i])
//     );
//     return match ? match.id : null;
//   }

//   // --- Show notification bar ---
//   async function showNotification(data) {
//     notificationBar.style.bottom = "-100%";
//     const p = notificationBar.querySelector("p");
//     p.textContent = data?.description || "Something went wrong";
//     notificationBar.style.bottom = "0";
//     setTimeout(() => (notificationBar.style.bottom = "-100%"), 5000);
//   }

//   // --- Add to Cart ---
//   async function addToCart(variantID, quantity) {
//     const payload = { items: [{ id: Number(variantID), quantity: Number(quantity) }] };
//     try {
//       const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });
//       const data = await res.json();
//       if (!res.ok) {
//         await showNotification(data);
//         return false;
//       }
//       await updateCartDrawer();
//       console.log("✅ Added to cart:", data);
//       return true;
//     } catch (err) {
//       console.error("❌ Add to cart failed:", err);
//       return false;
//     }
//   }

//   // --- Update cart drawer (same as yours) ---
//   async function updateCartDrawer() {
//     const path = window.location.pathname;
//     const search = window.location.search || "";
//     const sep = search ? "&" : "?";
//     const sectionUrl = `${path}${search}${sep}section_id=custom-cart-drawer`;

//     const data = await fetch(sectionUrl, { credentials: "same-origin" });
//     const text = await data.text();
//     const div = document.createElement("div");
//     div.innerHTML = text;

//     const newBottom = div.querySelector(".cart-drawer-bottom");
//     const newButtons = div.querySelector(".cart-drawer-buttons");

//     const bottomEl = document.querySelector(".cart-drawer-bottom");
//     const btnEl = document.querySelector(".cart-drawer-buttons");

//     if (newButtons && btnEl) btnEl.innerHTML = newButtons.innerHTML;
//     if (newBottom && bottomEl) bottomEl.innerHTML = newBottom.innerHTML;

//     const localePrefix = window.location.pathname.startsWith("/ar") ? "/ar" : "";
//     const cart = await fetch(`${localePrefix}/cart.js`).then((r) => r.json());
//     const countEl = document.querySelector(".custom-navbar-right-cart span");
//     if (countEl) countEl.textContent = cart.item_count;

//     updateSpendMore();
//     cartDrawerEventListeners();
//   }

//   // --- Update spend more section (same as yours) ---
//   function updateSpendMore() {
//     const spendMoreCartDrawer = document.querySelector(".cart-drawer-spend-more p");
//     const spendMoreWrapper = document.querySelector(".spend-more-wrapper");
//     const spendMoreHeight = spendMoreWrapper?.getAttribute("spend-more-height");
//     const spendMore = document.querySelector(".spend-more");

//     if (spendMoreCartDrawer) {
//       spendMoreWrapper.style.opacity = "1";
//       spendMoreWrapper.style.height = `${spendMoreHeight}px`;
//       spendMore.innerHTML = spendMoreCartDrawer.innerHTML;
//     } else {
//       spendMoreWrapper.style.opacity = "0";
//       spendMoreWrapper.style.height = "0px";
//     }
//   }

//   // --- Reattach cart drawer events ---
//   function cartDrawerEventListeners() {
//     document.querySelectorAll(".cart-drawer-product-remove-btn").forEach((btn) => {
//       btn.addEventListener("click", async () => {
//         const id = btn.closest(".cart-drawer-product")?.getAttribute("product-id");
//         await fetch(`${window.Shopify.routes.root}cart/change.js`, {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ id, quantity: 0 }),
//         });
//         await updateCartDrawer();
//       });
//     });
//   }

//   // --- Add to Cart button ---
//   if (addToCartBtn) {
//     addToCartBtn.addEventListener("click", async () => {
//       const variantID = getSelectedVariantId();
//       const qty = quantityInput ? quantityInput.value : 1;

//       if (!variantID) {
//         alert("Select a valid variant");
//         return;
//       }

//       const added = await addToCart(variantID, qty);
//       if (added) {
//         document.querySelector(".cart-drawer").classList.add("cart-toggle");
//         cartCon.classList.add("cart-container-toggle");
//       }
//     });
//   }

//   // --- Buy Now button ---
//   if (buyNowBtn) {
//     buyNowBtn.addEventListener("click", async () => {
//       const variantID = getSelectedVariantId();
//       const qty = quantityInput ? quantityInput.value : 1;

//       if (!variantID) {
//         alert("Select a valid variant");
//         return;
//       }

//       window.location.href = `/cart/${variantID}:${qty}`;
//     });
//   }

//   // Initialize
//   updateSpendMore();
//   cartDrawerEventListeners();
// } catch (error) {
//   console.error("❌ Script Error:", error);
// }

try {
  const variantRadios = document.querySelectorAll(".variant-radio");
  const addToCartBtn = document.querySelector(".a-t-c-btn");
  // const bundleAddToCartBtn = document.querySelector(".a-t-c-btn-bundle");
  const buyNowBtn = document.querySelector(".buy-product-btn");
  const quantityInput = document.querySelector(".product-quantity-input");
  const productEl = document.querySelector(".custom-product");
  const notificationBar = document.querySelector(".notification-bar-bottom");

  // 🔹 Parse variant JSON

  /* --------------------------------------------------------
     🔸 UNIVERSAL: Functions shared between normal & bundle
  -------------------------------------------------------- */

  async function showNotification(data) {
    notificationBar.style.bottom = "-100%";
    const p = notificationBar.querySelector("p");
    p.textContent = data?.description || "Something went wrong";
    notificationBar.style.bottom = "0";
    setTimeout(() => (notificationBar.style.bottom = "-100%"), 5000);
  }

  async function updateCartDrawer() {
    const path = window.location.pathname;
    const search = window.location.search || "";
    const sep = search ? "&" : "?";
    const sectionUrl = `${path}${search}${sep}section_id=custom-cart-drawer`;

    const data = await fetch(sectionUrl, { credentials: "same-origin" });
    const text = await data.text();
    const div = document.createElement("div");
    div.innerHTML = text;

    const newBottom = div.querySelector(".cart-drawer-bottom");
    const newButtons = div.querySelector(".cart-drawer-buttons");

    const bottomEl = document.querySelector(".cart-drawer-bottom");
    const btnEl = document.querySelector(".cart-drawer-buttons");

    if (newButtons && btnEl) btnEl.innerHTML = newButtons.innerHTML;
    if (newBottom && bottomEl) bottomEl.innerHTML = newBottom.innerHTML;

    const localePrefix = window.location.pathname.startsWith("/ar") ? "/ar" : "";
    const cart = await fetch(`${localePrefix}/cart.js`).then((r) => r.json());
    const countEl = document.querySelector(".custom-navbar-right-cart span");
    if (countEl) countEl.textContent = cart.item_count;

    updateSpendMore();
    cartDrawerEventListeners();

    const savedCurrency = localStorage.getItem("selectedCurrency") || "AED";
    updatePrices(savedCurrency);
  }

  function updateSpendMore() {
    const spendMoreCartDrawer = document.querySelector(".cart-drawer-spend-more p");
    const spendMoreWrapper = document.querySelector(".spend-more-wrapper");
    const spendMoreHeight = spendMoreWrapper?.getAttribute("spend-more-height");
    const spendMore = document.querySelector(".spend-more");

    if (spendMoreCartDrawer) {
      spendMoreWrapper.style.opacity = "1";
      spendMoreWrapper.style.height = `${spendMoreHeight}px`;
      spendMore.innerHTML = spendMoreCartDrawer.innerHTML;
    } else {
      spendMoreWrapper.style.opacity = "0";
      spendMoreWrapper.style.height = "0px";
    }
  }

  function cartDrawerEventListeners() {
    document.querySelectorAll(".cart-drawer-product-remove-btn").forEach((btn) => {
      btn.addEventListener("click", async () => {
        const id = btn.closest(".cart-drawer-product").getAttribute("product-id");
        await fetch(`${window.Shopify.routes.root}cart/change.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id, quantity: 0 }),
        });
        await updateCartDrawer();
      });
    });
  }

  /* --------------------------------------------------------
     🔸 NORMAL PRODUCT HANDLER
  -------------------------------------------------------- */
  function getSelectedVariantId() {
    const variants = JSON.parse(productEl.getAttribute("product-variant-json") || "[]");
    if(!variants) return;
    const selectedValues = [];
    const groups = ["productSizes", "productColor"];

    groups.forEach((group) => {
      const checked = document.querySelector(`input[name="${group}"]:checked`);
      if (checked) selectedValues.push(checked.value);
    });

    if (!selectedValues.length) return null;

    const match = variants.find((v) =>
      v.options.every((opt, i) => opt === selectedValues[i])
    );
    return match ? match.id : null;
  }

  async function addToCartSingle(variantID, quantity) {
    const payload = { items: [{ id: Number(variantID), quantity: Number(quantity) }] };
    try {
      const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (!res.ok) {
        await showNotification(data);
        return false;
      }
      await updateCartDrawer();
      console.log("✅ Added to cart:", data);
      return true;
    } catch (err) {
      console.error("❌ Add to cart failed:", err);
      return false;
    }
  }

  /* --------------------------------------------------------
     🔸 BUNDLE HANDLER
  -------------------------------------------------------- */
  
  function getSelectedBundleVariants() {
    const selectedRadio = document.querySelector(
      ".kaching-bundles__bar--selected"
    );
    if (!selectedRadio) return null;
    const bundleItems = selectedRadio.querySelectorAll(
      ".kaching-bundles__bar-variant-selects"
    );
    const selectedValues = [];
    bundleItems.forEach((item) => {
      const sizeEl = item.querySelector(
        '.kaching-bundles-option[data-name="Size"]'
      );
      const colorEl = item.querySelector(
        '.kaching-bundles-option[data-name="Color"] span span'
      );
      const size = sizeEl ? sizeEl.value : null;
      const color = colorEl ? colorEl.textContent.trim() : null;
      if (size && color) selectedValues.push([size, color]);
    });
    const productVariant = JSON.parse(
      document
        .querySelector(".custom-product")
        .getAttribute("product-variant-json")
    );
    const variantIDs = selectedValues.map((pair) => {
      const matchedVariant = productVariant.find((v) =>
        v.options.every((opt, i) => opt === pair[i])
      );
      return matchedVariant ? matchedVariant.id : null;
    });
    return variantIDs.filter(Boolean);
  }



  async function addToCartBundle() {
    const variantIDs = getSelectedBundleVariants();
    if (!variantIDs.length) {
      alert("Please select valid bundle variants.");
      return;
    }

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: variantIDs.map((id) => ({ id, quantity: 1 })),
        }),
      });
      const data = await res.json();
      console.log("✅ Added bundle to cart:", data);
      await updateCartDrawer();
    } catch (err) {
      console.error("❌ Add to cart failed:", err);
    }
  }

  /* --------------------------------------------------------
     🔸 BUTTON HANDLERS (Unified)
  -------------------------------------------------------- */
  if (addToCartBtn || buyNowBtn) {
    const handler = async () => {
      const selectedBundle = document.querySelector(".kaching-bundles__bar--selected");

      if (selectedBundle) {
        // 🧩 Bundle Mode
        await addToCartBundle();
        document.querySelector(".cart-drawer").classList.add("cart-toggle");
        cartCon.classList.add("cart-container-toggle");
        return true;
      } else {
        // 🧍 Normal Single Product Mode
        const variantID = getSelectedVariantId();
        const qty = quantityInput ? quantityInput.value : 1;

        if (!variantID) {
          alert("Select a valid variant");
          return;
        }

        const added = await addToCartSingle(variantID, qty);
        if (added) {
          document.querySelector(".cart-drawer").classList.add("cart-toggle");
          cartCon.classList.add("cart-container-toggle");
        }

        return true;
      }
    };

    document.addEventListener('click', async(e)=>{
      let btn = e.target.closest(".a-t-c-btn");
      // console.log(btn);
      if(btn){
        await handler();
      }
    })

    // addToCartBtn?.addEventListener("click", handler);
    // bundleAddToCartBtn?.addEventListener("click", handler);

  /* --------------------------------------------------------
     🔸 BUY NOW BUTTON
  -------------------------------------------------------- */
  if(buyNowBtn){
    buyNowBtn.addEventListener("click", async () => {
      // const variantID = getSelectedVariantId();
      // const qty = quantityInput ? quantityInput.value : 1;

      // if (!variantID) {
      //   alert("Select a valid variant");
      //   return;
      // }

      // window.location.href = `/cart/${variantID}:${qty}`;
      let added = await handler();
      if(added){
      window.location.href = `/checkout`;
      }
    });
  }
  }

  // Initialize
  updateSpendMore();
  cartDrawerEventListeners();
} catch (error) {
  console.error("❌ Script Error:", error);
}